var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "app-main-inner" },
        [
          _c(
            "el-form",
            {
              staticClass: "section",
              staticStyle: { "flex-direction": "row" },
              attrs: { disabled: _vm.readonly }
            },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { no: "booking" },
                  model: {
                    value: _vm.form.booking,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "booking", $$v)
                    },
                    expression: "form.booking"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Booking")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "customs" },
                  on: {
                    change: function(val) {
                      _vm.form.customsBroker = val ? _vm.form.customsBroker : 0
                      _vm.form.customsDeclarationType = val
                        ? _vm.form.customsDeclarationType
                        : -1
                    }
                  },
                  model: {
                    value: _vm.form.customs,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "customs", $$v)
                    },
                    expression: "form.customs"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.WhetherDeclarations")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "isInsure" },
                  model: {
                    value: _vm.form.insure,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "insure", $$v)
                    },
                    expression: "form.insure"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.InsureInfo")) + " ")]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "vgm" },
                  model: {
                    value: _vm.form.vgm,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "vgm", $$v)
                    },
                    expression: "form.vgm"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Vgm")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "ams" },
                  model: {
                    value: _vm.form.ams,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "ams", $$v)
                    },
                    expression: "form.ams"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Anti_terrorismShipping")))]
              ),
              _c(
                "el-checkbox",
                {
                  staticStyle: { "margin-left": "-20px" },
                  attrs: { no: "batch" },
                  model: {
                    value: _vm.form.batch,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "batch", $$v)
                    },
                    expression: "form.batch"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.InBatchesOrNot")))]
              ),
              _vm.isBookingNew
                ? _c(
                    "el-checkbox",
                    {
                      staticStyle: { "margin-left": "-20px" },
                      attrs: { no: "destinationPortService" },
                      on: {
                        change: function($event) {
                          return _vm.syncSlaves("destinationPortService")
                        }
                      },
                      model: {
                        value: _vm.form.destinationPortService,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "destinationPortService", $$v)
                        },
                        expression: "form.destinationPortService"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.PortOfDestinationServices"))
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _c("div", { staticStyle: { width: "fit-content" } }, [
            _c("div", { staticStyle: { display: "flex" } }, [
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        "label-width": "120px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.BookingInfo")))
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BusinessNo") } },
                        [
                          _c("el-input", {
                            attrs: { value: _vm.form.jobNo, disabled: true }
                          })
                        ],
                        1
                      ),
                      _vm.isZY
                        ? [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "blue",
                                    attrs: { slot: "label" },
                                    slot: "label"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.AllowSaleProduct")
                                      )
                                    )
                                  ]
                                ),
                                _c("cargo-advance-select", {
                                  attrs: {
                                    "select-type":
                                      _vm.selectTypeNames
                                        .basic_data_AllowSaleProduct,
                                    filterable: "",
                                    no: "allowSaleProduct",
                                    clearable: "",
                                    "data-filter-function": function(p) {
                                      if (!p.statusEnabled) {
                                        return false
                                      }
                                      return _vm.isFba
                                        ? p.fbaSea
                                        : p.seaExportEnabled
                                    },
                                    "default-value":
                                      this.form.saleProductCode || ""
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      this$1.form.saleProductCode = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "blue",
                                    attrs: { slot: "label" },
                                    slot: "label"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.FullOrInside"))
                                    )
                                  ]
                                ),
                                _c("cargo-advance-select", {
                                  attrs: {
                                    "select-type":
                                      _vm.selectTypeNames
                                        .local_cache_FullOrInside$FULL_OR_INSIDE,
                                    no: "fullOrInside",
                                    clearable: "",
                                    "default-value":
                                      this.form.fullOrInside || ""
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      this$1.form.fullOrInside = p.value
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm.form.containerLoadType === _vm.BC_CARGO_TYPE.code
                        ? [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.ConsignationCompany")
                                }
                              },
                              [
                                _c("cargo-sales-company-select", {
                                  staticClass: "shipper-selector",
                                  attrs: {
                                    no: "customerId",
                                    "popper-class": "shipper-selector-popper",
                                    "method-params": {
                                      customer: true,
                                      companyLob: "seaExport",
                                      active: true
                                    },
                                    "check-credit": true,
                                    "default-value": _vm.form.customerId || "",
                                    job: _vm.form
                                  },
                                  on: { parentCallBack: _vm.customerIdChange }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.CustomerProperty")
                                }
                              },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: _vm.customerTip,
                                      placement: "bottom"
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              (_vm.contractStatus === 2 &&
                                                typeof _vm.customerLevel
                                                  .level === "number") ||
                                              parseInt(
                                                _vm.customerLevel.level
                                              ) > -1,
                                            expression:
                                              "(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
                                          }
                                        ],
                                        staticClass: "orange"
                                      },
                                      [
                                        _vm._v(
                                          "LV" + _vm._s(_vm.customerLevel.level)
                                        )
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              (_vm.contractStatus === 2 &&
                                                typeof _vm.customerLevel
                                                  .level === "number") ||
                                              parseInt(
                                                _vm.customerLevel.level
                                              ) > -1,
                                            expression:
                                              "(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
                                          }
                                        ],
                                        staticStyle: { color: "#D3A73B" }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.customerLevel.customerName
                                            )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.contractStatusLabel,
                                            expression: "contractStatusLabel"
                                          }
                                        ],
                                        staticClass: "red"
                                      },
                                      [
                                        _vm._v(
                                          " (" +
                                            _vm._s(_vm.contractStatusLabel) +
                                            ")"
                                        )
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.advancePaymentLabel,
                                            expression: "advancePaymentLabel"
                                          }
                                        ],
                                        staticStyle: { color: "brown" }
                                      },
                                      [
                                        _vm._v(
                                          " (" +
                                            _vm._s(_vm.advancePaymentLabel) +
                                            ")"
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("SeaExport.ContactPerson")
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          no: "customerContact",
                                          filterable: "",
                                          "allow-create": true
                                        },
                                        model: {
                                          value: _vm.form.customerContact,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "customerContact",
                                              $$v
                                            )
                                          },
                                          expression: "form.customerContact"
                                        }
                                      },
                                      _vm._l(_vm.contactList, function(
                                        item,
                                        index
                                      ) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.contactPerson,
                                            value: item.contactPerson
                                          }
                                        })
                                      }),
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-link",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.isShowContactPersonDetail,
                                            expression:
                                              "!isShowContactPersonDetail"
                                          }
                                        ],
                                        class: _vm.form.customerContact
                                          ? ""
                                          : "not-click",
                                        attrs: { no: "customerContactLink" },
                                        on: { click: _vm.showContactDialog }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("SeaExport.Detail")) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.FLCLType") } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { no: "containerLoadType" },
                              on: {
                                change: function($event) {
                                  _vm.pm.selectDefaultCutomJobType()
                                  _vm.pm.containerLoadTypeChange()
                                }
                              },
                              model: {
                                value: _vm.form.containerLoadType,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "containerLoadType", $$v)
                                },
                                expression: "form.containerLoadType"
                              }
                            },
                            _vm._l(_vm.containerLoadTypes, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm.isZh
                                    ? item.chineseName
                                    : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BookingDate") } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "bookingDate",
                              disabled: _vm.readonly,
                              type: "date",
                              clearable: "",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.bookingDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "bookingDate", $$v)
                              },
                              expression: "form.bookingDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-form-item", [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.DateOfDeparture2")))]
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticClass: "departure-date-picker",
                              staticStyle: { flex: "1", "margin-right": "5px" },
                              attrs: {
                                no: "etd",
                                value: _vm.form.etd,
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                placeholder: _vm.$t("SeaExport.RequiredItem"),
                                disabled: !_vm.isJydEditJobFields
                              },
                              on: { input: _vm.etdChange }
                            }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("filterWeek")(_vm.form.sailingDay)
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ]),
                      _c("el-form-item", [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.DateOfArrival2")))]
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1", "margin-right": "5px" },
                              attrs: {
                                no: "eta",
                                type: "date",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { input: _vm.etaChange },
                              model: {
                                value: _vm.form.eta,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "eta", $$v)
                                },
                                expression: "form.eta"
                              }
                            }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("filterWeek")(_vm.form.etaSailingDay)
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ]),
                      _c("el-form-item", [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.ActualDateOfDeparture2"))
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1", "margin-right": "5px" },
                              attrs: {
                                value: _vm.form.atd,
                                no: "atd",
                                type: "date",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { input: _vm.atdChange }
                            }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("filterWeek")(_vm.form.atdSailingDay)
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ]),
                      _c("el-form-item", [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.ActualDateOfArrival2"))
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { flex: "1", "margin-right": "5px" },
                              attrs: {
                                no: "ata",
                                type: "date",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { input: _vm.ataChange },
                              model: {
                                value: _vm.form.ata,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "ata", $$v)
                                },
                                expression: "form.ata"
                              }
                            }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("filterWeek")(_vm.form.ataSailingDay)
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.OperationDate") } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              disabled: !_vm.isJydUpdateCustomsDate,
                              no: "customsDate",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.customsDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "customsDate", $$v)
                              },
                              expression: "form.customsDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c("el-form-item", [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.PortOfLoading")))]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              ref: "loadingPortCode",
                              staticStyle: { width: "128px" },
                              attrs: {
                                no: "loadingPortCode",
                                "select-type":
                                  _vm.selectTypeNames.basic_data_Seaport,
                                filterable: "",
                                "default-value": _vm.form.loadingPortCode,
                                "tag-name": "englishName",
                                placeholder: _vm.$t("SeaExport.RequiredItem")
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.pm.loadingPortCodeChange(p)
                                  _vm.pm.cargoDocChangeHandler()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "el-checkbox",
                              {
                                staticStyle: { "padding-left": "2px" },
                                attrs: { no: "transfering" },
                                on: {
                                  change: function($event) {
                                    return _vm.pm.updateSecondVesselInfo()
                                  }
                                },
                                model: {
                                  value: _vm.form.transfering,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "transfering", $$v)
                                  },
                                  expression: "form.transfering"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Transit")))]
                            )
                          ],
                          1
                        )
                      ]),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.transfering,
                              expression: "form.transfering"
                            }
                          ],
                          attrs: { label: _vm.$t("SeaExport.TransitPort") }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "transferPortCode",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value": _vm.form.transferPortCode,
                              placeholder: _vm.$t("SeaExport.RequiredItem")
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.transferPortCode = p.value
                                _vm.pm.updateSecondVesselInfo()
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.PortOfDischarge"))
                              )
                            ]
                          ),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "dischargingPortCode",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value": _vm.form.dischargingPortCode,
                              placeholder: _vm.$t("SeaExport.RequiredItem")
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.dischargingPortCodeChange(
                                  p,
                                  _vm.form.carrierId
                                )
                                _vm.pm.cargoDocChangeHandler()
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.PlaceOfDelivery"))
                              )
                            ]
                          ),
                          _c("cargo-advance-select", {
                            staticClass: "port-of-delivery-selector",
                            attrs: {
                              no: "destinationPortCode",
                              "popper-class":
                                "port-of-delivery-selector-popper",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Seaport,
                              filterable: "",
                              "default-value": _vm.form.destinationPortCode,
                              placeholder: _vm.$t("SeaExport.RequiredItem")
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.destinationPortCodeChange(p)
                                _vm.pm.cargoDocChangeHandler()
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_PlaceOfDeliveryRegion")
                                )
                              )
                            ]
                          ),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "placeOfDeliveryRegion",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Region,
                              filterable: "",
                              "default-value": _vm.form.placeOfDeliveryRegion
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.placeOfDeliveryRegion = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.TransshipmentTransportationMethod"
                                  )
                                )
                              )
                            ]
                          ),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "transportationMode",
                              "static-options": _vm.transportationModeInfos,
                              "filter-tag-names": [
                                "chineseName",
                                "englishName",
                                "code"
                              ],
                              filterable: "",
                              "tag-name": "englishName",
                              "default-value":
                                _vm.form.transshipmentTransportationModeCode
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.transshipmentTransportationModeCode =
                                  p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm.bookingAgentVisible
                        ? _c(
                            "el-form-item",
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.BookingAgent"))
                                  )
                                ]
                              ),
                              !_vm.isJoinCarrierBookingAgent ||
                              _vm.form.containerLoadType === "BB"
                                ? _c("cargo-company-select", {
                                    staticClass: "booking-agent-selector",
                                    attrs: {
                                      no: "bookingAgent",
                                      "popper-class":
                                        "booking-agent-selector-popper",
                                      disabled: !_vm.bookingAgentEnabled,
                                      "method-params": {
                                        bookingAgent: true,
                                        active: true
                                      },
                                      "default-value":
                                        _vm.form.bookingAgent || "",
                                      placeholder: _vm.$t(
                                        "SeaExport.RequiredItem"
                                      )
                                    },
                                    on: {
                                      change: function(p) {
                                        _vm.pm.bookingAgentChange(p)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm.isJoinCarrierBookingAgent &&
                              _vm.form.containerLoadType !== "BB"
                                ? _c("cargo-advance-select", {
                                    staticClass: "booking-agent-selector",
                                    attrs: {
                                      no: "bookingAgent",
                                      "popper-class":
                                        "booking-agent-selector-popper",
                                      disabled: !_vm.bookingAgentEnabled,
                                      "select-type":
                                        _vm.selectTypeNames.static_data_Company,
                                      cache: false,
                                      filterable: "",
                                      "default-value":
                                        _vm.form.bookingAgent || "",
                                      "static-options": _vm.bookingAgentList,
                                      placeholder: _vm.$t(
                                        "SeaExport.RequiredItem"
                                      )
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.pm.bookingAgentChange(p)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.CarrierAgent") } },
                        [
                          _c("cargo-company-select", {
                            attrs: {
                              no: "carrierAgentId",
                              "method-params": {
                                seaCmpAgent: true,
                                active: true
                              },
                              "default-value": _vm.form.carrierAgentId || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.form.carrierAgentId = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Message.TerminalCompany") } },
                        [
                          _c("cargo-company-select", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "terminalCompany",
                              "method-params": {
                                terminalCompany: true,
                                companyLob: "seaExport",
                                active: true
                              },
                              "default-value": _vm.form.terminalCompany || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.JobUtils.terminalCompanyChangeHandler(
                                  _vm.form,
                                  p
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.ShippingCompany") }
                        },
                        [
                          _c("cargo-company-select", {
                            ref: "shippingCompany",
                            attrs: {
                              no: "carrierId",
                              disabled: !_vm.carrierIdEnabled,
                              "method-params": {
                                companyLob: "seaExport",
                                seaCmp: true,
                                active: true
                              },
                              "default-value": _vm.form.carrierId || ""
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.carrierChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.SolicitationType") }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    no: "cargoSource",
                                    placeholder: _vm.$t(
                                      "SeaExport.PleaseSelect"
                                    ),
                                    clearable: false,
                                    size: "mini"
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.form.designationAgent = 0
                                      _vm.pm.cargoSourceChange()
                                    }
                                  },
                                  model: {
                                    value: _vm.form.cargoSource,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "cargoSource", $$v)
                                    },
                                    expression: "form.cargoSource"
                                  }
                                },
                                _vm._l(_vm.CARGO_SOURCES, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: _vm.isZh
                                        ? item.chineseName
                                        : item.englishName,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.CustomJobType") } },
                        [
                          _c("cargo-advance-select", {
                            ref: "customJobType",
                            attrs: {
                              no: "customJobType",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CutomJobType,
                              filterable: "",
                              "tag-name": _vm.isZh ? "name" : "englishName",
                              "static-options": _vm.customJobTypeList,
                              "method-params": { type: _vm.form.lob },
                              "default-value": _vm.form.customJobType
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.customJobType = p.value
                                _vm.onCustomJobTypeChange()
                                _vm.contractRuleFieldChange(
                                  _vm.form.customerId,
                                  _vm.form.designationAgent
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm.form.customJobType &&
                      _vm.secondaryCustomJobTypeList.length > 0
                        ? _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_Grade") }
                            },
                            [
                              _c("cargo-advance-select", {
                                ref: "secondaryCustomJobType",
                                attrs: {
                                  no: "secondaryCustomJobType",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_CutomJobType,
                                  filterable: "",
                                  cache: false,
                                  "default-value":
                                    _vm.form.secondaryCustomJobType,
                                  "tag-name": _vm.isZh ? "name" : "englishName",
                                  "static-options":
                                    _vm.secondaryCustomJobTypeList
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.secondaryCustomJobType = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.PortOfLoadingAgent")
                          }
                        },
                        [
                          _c("cargo-company-select", {
                            attrs: {
                              "method-params": {
                                localAgent: true,
                                active: true
                              },
                              "default-value": _vm.form.loadingAgentId || "",
                              no: "loadingAgentId",
                              disabled: _vm.readonly,
                              "data-filter-function":
                                _vm.JobUtils.loadingAgentIdFilter,
                              "tag-name": _vm.isZh
                                ? "chineseName"
                                : "englishName"
                            },
                            on: {
                              change: function(p) {
                                _vm.form.loadingAgentId = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("queryJob.destinationAgent") }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.destinationAgentTip,
                                disabled: !_vm.showDestinationAgentWarning,
                                placement: "right-end"
                              }
                            },
                            [
                              _c("cargo-company-select", {
                                ref: "destinationAgent",
                                attrs: {
                                  no: "destinationAgent",
                                  "method-params": {
                                    overseaAgent: true,
                                    active: true
                                  },
                                  "check-credit": true,
                                  job: _vm.form,
                                  "default-value":
                                    _vm.form.destinationAgent || "",
                                  filterable: "",
                                  headers: [_vm.$t("Partners.englishName")],
                                  fields: ["englishName"],
                                  "tag-name": "englishName"
                                },
                                on: {
                                  change: function(p) {
                                    _vm.pm.txtDestinationAgentChangeHandler(p)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.form.cargoSource === "NC",
                              expression: "form.cargoSource==='NC'"
                            }
                          ]
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.NominatedAgent")))]
                          ),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: _vm.designationAgentTip,
                                disabled: !_vm.showDesignationAgentWarning,
                                placement: "right-end"
                              }
                            },
                            [
                              _c("cargo-company-select", {
                                staticClass: "designation-agent-selector",
                                attrs: {
                                  no: "designationAgent",
                                  "popper-class":
                                    "designation-agent-selector-popper",
                                  disabled: !_vm.designationAgentEnabled,
                                  "method-params": {
                                    designationAgent: true,
                                    active: true
                                  },
                                  "check-credit": true,
                                  job: _vm.form,
                                  "default-value":
                                    _vm.form.designationAgent || "",
                                  filterable: "",
                                  headers: [_vm.$t("Partners.englishName")],
                                  fields: ["englishName"],
                                  "tag-name": "englishName"
                                },
                                on: {
                                  change: function(p) {
                                    _vm.pm.txtDesignationAgentChangeHandler(p)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.BillExchangeAgent")
                          }
                        },
                        [
                          _c("cargo-company-select", {
                            attrs: {
                              no: "exChangeAgent",
                              disabled: !_vm.form.dischargingPortDoor,
                              "method-params": {
                                bookingAgent: true,
                                active: true
                              },
                              "default-value": _vm.form.exChangeAgent || ""
                            },
                            on: { change: _vm.onExChangeAgentChange }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_TransportSource")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_TransportSource,
                              no: "transportSource",
                              "default-value": _vm.form.transportSource,
                              cache: false,
                              "tag-value": "code",
                              placeholder: " "
                            },
                            on: {
                              parentCallBack: function(item) {
                                return (_vm.form.transportSource = item.value)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_ServiceStatisticalArea"
                            )
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_StatisticArea,
                              no: "statisticArea",
                              "default-value": _vm.form.statisticArea,
                              cache: false,
                              "tag-value": "code",
                              placeholder: " "
                            },
                            on: {
                              parentCallBack: function(item) {
                                return (_vm.form.statisticArea = item.value)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm.isFba
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.ServiceChannel")
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.fbaJob.serviceChannel,
                                  callback: function($$v) {
                                    _vm.$set(_vm.fbaJob, "serviceChannel", $$v)
                                  },
                                  expression: "fbaJob.serviceChannel"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        "label-width": "140px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(_vm.$t("SeaExport.AdditionalInformation"))
                        )
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.LocalService") } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { display: "block" },
                              attrs: { no: "warehousing" },
                              on: {
                                change: function($event) {
                                  return _vm.pm.loadingTermChange("warehousing")
                                }
                              },
                              model: {
                                value: _vm.form.warehousing,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "warehousing", $$v)
                                },
                                expression: "form.warehousing"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.WarehouseLoadingStorage")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { display: "block" },
                              attrs: { no: "landTransportation" },
                              on: {
                                change: function($event) {
                                  return _vm.pm.loadingTermChange(
                                    "landTransportation"
                                  )
                                }
                              },
                              model: {
                                value: _vm.form.landTransportation,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "landTransportation", $$v)
                                },
                                expression: "form.landTransportation"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.DoorLoadingDelivery"))
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { display: "block" },
                              attrs: { no: "selfDeliver" },
                              model: {
                                value: _vm.form.selfDeliver,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "selfDeliver", $$v)
                                },
                                expression: "form.selfDeliver"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.NotResponsibleForTruckingAndLoading"
                                  )
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { no: "backUpWarehouse" },
                              on: {
                                change: function($event) {
                                  return _vm.pm.backUpWarehouseChange()
                                }
                              },
                              model: {
                                value: _vm.form.backUpWarehouse,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "backUpWarehouse", $$v)
                                },
                                expression: "form.backUpWarehouse"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.BackUpWarehouse")) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm.isBookingNew && _vm.form.destinationPortService
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SeaExport.PortOfDestinationServices"
                                )
                              }
                            },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { display: "block" },
                                  attrs: { no: "dischargingPortDoor" },
                                  on: {
                                    change: function($event) {
                                      return _vm.syncSlaves(
                                        "dischargingPortDoor"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.form.dischargingPortDoor,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "dischargingPortDoor",
                                        $$v
                                      )
                                    },
                                    expression: "form.dischargingPortDoor"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SeaExport.DispatchVehiclesAtDestination"
                                      )
                                    ) + " "
                                  )
                                ]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { display: "block" },
                                  attrs: { no: "usCustomsClearance" },
                                  on: {
                                    change: function($event) {
                                      return _vm.syncSlaves(
                                        "usCustomsClearance"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.form.usCustomsClearance,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "usCustomsClearance",
                                        $$v
                                      )
                                    },
                                    expression: "form.usCustomsClearance"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("queryJob.UsCustomsClearance")
                                    ) + " "
                                  )
                                ]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { display: "block" },
                                  attrs: { no: "destPortCustomsClearance" },
                                  on: {
                                    change: function($event) {
                                      return _vm.syncSlaves(
                                        "destPortCustomsClearance"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.form.destPortCustomsClearance,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "destPortCustomsClearance",
                                        $$v
                                      )
                                    },
                                    expression: "form.destPortCustomsClearance"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SeaExport.PortOfDestinationCustomsClearance"
                                      )
                                    ) + " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            id: "customerRefNo",
                            label: _vm.$t("SeaExport.BusinessReferenceNo")
                          }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                disabled: !_vm.customerRefNoTip,
                                content: _vm.customerRefNoTip,
                                placement: "right-end"
                              }
                            },
                            [
                              _c("el-input", {
                                class: _vm.customerRefNoTip ? "red" : "",
                                attrs: { no: "customerRefNo" },
                                on: {
                                  blur: function($event) {
                                    return _vm.pm.customerRefNoFocusOutHandler()
                                  }
                                },
                                model: {
                                  value: _vm.form.customerRefNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "customerRefNo", $$v)
                                  },
                                  expression: "form.customerRefNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.form.cargoSource === "NC"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                id: "agentRefNo",
                                label: _vm.$t("SeaExport.NCReferenceNo")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "agentRefNo" },
                                model: {
                                  value: _vm.form.agentRefNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "agentRefNo", $$v)
                                  },
                                  expression: "form.agentRefNo"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          class: _vm.poNoRed ? "poNoClass" : "",
                          attrs: { label: _vm.$t("SeaExport.ItemNo") }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "poNo" },
                            model: {
                              value: _vm.form.poNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "poNo", $$v)
                              },
                              expression: "form.poNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.MBLTransportationClause")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "freightTerm",
                              "select-type":
                                _vm.selectTypeNames.basic_data_ShippingTerm,
                              filterable: "",
                              "default-value": _vm.form.freightTerm
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.freightTerm = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.MasterBLFreightTerm")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "paymentTermMBL",
                              "select-type":
                                _vm.selectTypeNames.basic_data_PaymentTerm,
                              filterable: "",
                              "default-value": _vm.form.paymentTermMBL
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.paymentTermMBL = p.value
                                _vm.pm.paymentTermMBLChange()
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.CustomsBroker") } },
                        [
                          _c("cargo-company-select", {
                            attrs: {
                              no: "customsBroker",
                              disabled: !_vm.customsBrokerEnabled,
                              "method-params": {
                                customsBroker: true,
                                companyLob: "seaExport",
                                active: true
                              },
                              "default-value": _vm.form.customsBroker || "",
                              placeholder: _vm.$t(
                                "SeaExport.PleaseTickCustomsDeclarationOption"
                              ),
                              "data-filter-function": _vm.customsBrokerFilter
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.customsBrokerChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      !_vm.isFba
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SeaExport.CustomsDeclarationMethod"
                                )
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "customsMethod",
                                  disabled: !_vm.customsBrokerEnabled,
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_CustomsMode,
                                  "method-params": { serviceType: 2 },
                                  "tag-value": "serialNum",
                                  filterable: "",
                                  "default-value": _vm.form.customClaim
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.customClaim = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CustomsDeclarationType")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "customsDeclarationType",
                              disabled: !_vm.customsBrokerEnabled,
                              "select-type":
                                _vm.selectTypeNames
                                  .basic_data_CustomsDeclarationType,
                              filterable: "",
                              "default-value":
                                _vm.form.customsDeclarationType === -1
                                  ? ""
                                  : _vm.form.customsDeclarationType,
                              placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.customsDeclarationType = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm.isFba
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SeaExport.CustomsDeclarationMethod"
                                )
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "customsMethodPol",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_CustomsMode,
                                  "method-params": { serviceType: 0 },
                                  filterable: "",
                                  clearable: false,
                                  "default-value": _vm.fbaJob.customsMethodPol
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.fbaJob.customsMethodPol = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isFba
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.ClearanceMethod")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "customsMethodPod",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_CustomsMode,
                                  "method-params": { serviceType: 1 },
                                  filterable: "",
                                  clearable: false,
                                  "default-value": _vm.fbaJob.customsMethodPod
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.fbaJob.customsMethodPod = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.TradeMethod") } },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "tradeTerm",
                              "select-type":
                                _vm.selectTypeNames.basic_data_TradeTerm,
                              filterable: "",
                              "default-value": _vm.form.tradeTerm
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.tradeTerm = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.HaulageCompany") }
                        },
                        [
                          _c("cargo-company-select", {
                            attrs: {
                              no: "carryingCmp",
                              disabled: !_vm.form.landTransportation,
                              "method-params": { truckCmp: true, active: true },
                              "default-value": _vm.form.carryingCmp || "",
                              placeholder: _vm.$t(
                                "SeaExport.PleaseTickDoorLoadingDeliveryOption"
                              )
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.carryingCmpChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm.isFba
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SeaExport.EstimatedStorageReadyGoodsTime"
                                )
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "preWarehousingTime",
                                  type: "date",
                                  clearable: "",
                                  "value-format": "yyyy-MM-dd",
                                  format: "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.fbaJob.preWarehousingTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.fbaJob,
                                      "preWarehousingTime",
                                      $$v
                                    )
                                  },
                                  expression: "fbaJob.preWarehousingTime"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.isFba
                              ? _vm.$t("SeaExport.DomesticWarehouse")
                              : _vm.openWarehouse
                              ? _vm.$t("SeaExport.WarehouseSupplier")
                              : _vm.$t("SeaExport.Warehouse")
                          }
                        },
                        [
                          _c("cargo-company-select", {
                            attrs: {
                              no: "warehouseCmp",
                              disabled: !_vm.warehouseEabled,
                              "method-params": {
                                warehouse: true,
                                active: true
                              },
                              "default-value": _vm.form.warehouseCmp || "",
                              placeholder: _vm.$t(
                                "SeaExport.PleaseSelectWarehouse"
                              )
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.warehouseCmpChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm.openWarehouse && !_vm.isFba
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.WareHouseName")
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  ref: "warehouseName",
                                  attrs: {
                                    no: "warehouseName",
                                    disabled:
                                      !_vm.warehouseEabled ||
                                      !_vm.form.warehouseCmp,
                                    "allow-create": true,
                                    filterable: "",
                                    clearable: true
                                  },
                                  on: {
                                    change: _vm.warehouseNameChangeHandler
                                  },
                                  model: {
                                    value: _vm.form.warehouseName,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "warehouseName", $$v)
                                    },
                                    expression: "form.warehouseName"
                                  }
                                },
                                _vm._l(_vm.warehouseNameList, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.warehouseName,
                                      value: item.warehouseName
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.BackUpWarehouse") }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "backUpWarehouseCmp",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              cache: false,
                              disabled: !_vm.backUpWarehouseEnabled,
                              "default-value":
                                _vm.form.backUpWarehouseCmp || "",
                              filterable: "",
                              "static-options": _vm.backUpWarehouseCompanyList,
                              placeholder: !_vm.backUpWarehouseEnabled
                                ? _vm.$t(
                                    "SeaExport.PleaseSelectBackUpWarehouse"
                                  )
                                : _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.backUpWarehouseCmpChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm.isFba
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SeaExport.ForeignWarehouse")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "overseaWarehouseCode",
                                  "select-type":
                                    _vm.selectTypeNames
                                      .basic_data_OverseaWarehouse,
                                  filterable: "",
                                  "method-params": { ifFba: false },
                                  clearable: false,
                                  "tag-name": "chineseName",
                                  "default-value": _vm.form.overseaWarehouseCode
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.overseaWarehouseCode = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.ContractRateProperty")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                no: "bookingTerm",
                                placeholder: _vm.readonly
                                  ? ""
                                  : _vm.$t("SeaExport.PleaseSelect"),
                                clearable: "",
                                size: "mini"
                              },
                              model: {
                                value: _vm.form.bookingTerm,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "bookingTerm", $$v)
                                },
                                expression: "form.bookingTerm"
                              }
                            },
                            _vm._l(_vm.bookingTerms, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm.isZh
                                    ? item.chineseName
                                    : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.TradeTerms2") } },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "incoTerm",
                              "select-type":
                                _vm.selectTypeNames.basic_data_IncoTerm,
                              filterable: "",
                              "default-value": _vm.form.incoTerm
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.incoTerm = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.WarehousingInfo") }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: true,
                              type: "textarea",
                              rows: 2,
                              value: _vm.txtWhs,
                              placeholder: _vm.$t("Message.NoStorageInfo")
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                        [
                          _c("el-input", {
                            attrs: { no: "remarks", type: "textarea", rows: 2 },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.Remarks"),
                                  _vm.form.remarks,
                                  function(val) {
                                    _vm.form.remarks = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "remarks", $$v)
                              },
                              expression: "form.remarks"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-around"
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              staticStyle: { margin: "0" },
                              attrs: { no: "allocation" },
                              model: {
                                value: _vm.form.allocation,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "allocation", $$v)
                                },
                                expression: "form.allocation"
                              }
                            },
                            [_vm._v(_vm._s("Allocation") + " ")]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              attrs: { no: "availableCabinSpace" },
                              model: {
                                value: _vm.form.availableCabinSpace,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "availableCabinSpace", $$v)
                                },
                                expression: "form.availableCabinSpace"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_AvailableCabinSpace")
                                ) + " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  class:
                    "section form-column " +
                    _vm.$selectByLang(
                      "form-item-label",
                      "form-item-label",
                      "form-item-label-ja"
                    )
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        "label-width": _vm.$selectByLang("145px", "", "170px"),
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.ContainerInfo2")))
                      ]),
                      _c("booking-sea-eq-data-grid", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "seaEqList",
                          value: _vm.seaEqList,
                          "container-load-type": _vm.form.containerLoadType,
                          "is-edit": _vm.isEdit,
                          job: _vm.form
                        },
                        on: {
                          cellChange: function() {
                            _vm.pm.dgSeaEqItemEditEndHandler()
                          },
                          eqQuantityChange: _vm.eqQuantityChangeHandler
                        }
                      }),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.QuantityConsignActual")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("auto-number-input", {
                                attrs: {
                                  no: "quantityContract",
                                  precision: 0,
                                  min: 0,
                                  disabled: !_vm.isJydEditJobFields
                                },
                                on: {
                                  change: function($event) {
                                    _vm.SEUtils.changeQWCRule(function() {
                                      _vm.form.quantityActual =
                                        _vm.form.quantityContract
                                    })
                                    _vm.pm.txtPackingChangeHandler()
                                  }
                                },
                                model: {
                                  value: _vm.form.quantityContract,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "quantityContract", $$v)
                                  },
                                  expression: "form.quantityContract"
                                }
                              }),
                              _c(
                                "span",
                                { staticStyle: { padding: "0 2px" } },
                                [_vm._v("/")]
                              ),
                              _c("auto-number-input", {
                                attrs: {
                                  no: "quantityActual",
                                  precision: 0,
                                  min: 0,
                                  disabled: !_vm.isJydEditJobFields
                                },
                                on: {
                                  change: function($event) {
                                    _vm.SEUtils.changeQWCRule(null, function() {
                                      _vm.form.quantityContract =
                                        _vm.form.quantityActual
                                    })
                                  }
                                },
                                model: {
                                  value: _vm.form.quantityActual,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "quantityActual", $$v)
                                  },
                                  expression: "form.quantityActual"
                                }
                              }),
                              _c("span", [_vm._v("PCS")])
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.WeightConsignActual")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("auto-number-input", {
                                attrs: {
                                  no: "weightContract",
                                  precision: 3,
                                  min: 0,
                                  disabled: !_vm.isJydEditJobFields
                                },
                                on: { change: _vm.weightContractChange },
                                model: {
                                  value: _vm.form.weightContract,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "weightContract", $$v)
                                  },
                                  expression: "form.weightContract"
                                }
                              }),
                              _c(
                                "span",
                                { staticStyle: { padding: "0 2px" } },
                                [_vm._v("/")]
                              ),
                              _c("auto-number-input", {
                                attrs: {
                                  no: "weightActual",
                                  precision: 3,
                                  min: 0,
                                  disabled: !_vm.isJydEditJobFields
                                },
                                on: { change: _vm.weightActualChange },
                                model: {
                                  value: _vm.form.weightActual,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "weightActual", $$v)
                                  },
                                  expression: "form.weightActual"
                                }
                              }),
                              _c("span", [_vm._v("KGS")])
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CubageConsignActual")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("auto-number-input", {
                                attrs: {
                                  no: "cubageContract",
                                  precision: 3,
                                  disabled:
                                    !_vm.cubageActualEnabled ||
                                    !_vm.isJydEditJobFields,
                                  min: 0
                                },
                                on: { change: _vm.cubageContractChange },
                                model: {
                                  value: _vm.form.cubageContract,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "cubageContract", $$v)
                                  },
                                  expression: "form.cubageContract"
                                }
                              }),
                              _c(
                                "span",
                                { staticStyle: { padding: "0 2px" } },
                                [_vm._v("/")]
                              ),
                              _c("auto-number-input", {
                                attrs: {
                                  no: "cubageActual",
                                  precision: 3,
                                  min: 0,
                                  disabled: !_vm.isJydEditJobFields
                                },
                                on: { change: _vm.cubageActualChange },
                                model: {
                                  value: _vm.form.cubageActual,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "cubageActual", $$v)
                                  },
                                  expression: "form.cubageActual"
                                }
                              }),
                              _c("span", [_vm._v("CBM")])
                            ],
                            1
                          )
                        ]
                      ),
                      _vm.isFba
                        ? _c(
                            "el-form-item",
                            { attrs: { "label-width": "0" } },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-around",
                                    "margin-left": "-50px"
                                  }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: {
                                        "margin-right": "10px",
                                        "margin-left": "20px"
                                      },
                                      model: {
                                        value: _vm.fbaJob.electric,
                                        callback: function($$v) {
                                          _vm.$set(_vm.fbaJob, "electric", $$v)
                                        },
                                        expression: "fbaJob.electric"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.WithElectricity")
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { "margin-right": "10px" },
                                      model: {
                                        value: _vm.fbaJob.magnetic,
                                        callback: function($$v) {
                                          _vm.$set(_vm.fbaJob, "magnetic", $$v)
                                        },
                                        expression: "fbaJob.magnetic"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.WithMagnetism")
                                        )
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { "margin-right": "10px" },
                                      model: {
                                        value: _vm.fbaJob.powdery,
                                        callback: function($$v) {
                                          _vm.$set(_vm.fbaJob, "powdery", $$v)
                                        },
                                        expression: "fbaJob.powdery"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("SeaExport.Powder")))]
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { "margin-right": "10px" },
                                      model: {
                                        value: _vm.fbaJob.liquid,
                                        callback: function($$v) {
                                          _vm.$set(_vm.fbaJob, "liquid", $$v)
                                        },
                                        expression: "fbaJob.liquid"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("SeaExport.Liquid")))]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Package") } },
                        [
                          _c("cargo-packing-select", {
                            ref: "packing",
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "packing",
                              "default-value": _vm.form.packing
                            },
                            on: {
                              change: function(p) {
                                _vm.form.packing = p.value
                                _vm.pm.txtPackingChangeHandler()
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.ChargedWeightRT") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input-number", {
                                staticStyle: { flex: "1" },
                                attrs: {
                                  no: "chargeWeight",
                                  value: _vm.form.chargeWeight || undefined,
                                  precision: 3,
                                  min: 0,
                                  controls: false
                                },
                                on: {
                                  input: function(val) {
                                    _vm.form.chargeWeight = val
                                    _vm.context.reloadCharge = true
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.isFba ? "KGS" : "M/T"))
                              ])
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "div",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SeaExport.ChineseDescriptionOfGoods"
                                    )
                                  )
                                )
                              ]),
                              _c("br"),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isEdit,
                                      expression: "isEdit"
                                    }
                                  ],
                                  attrs: {
                                    no: "MergingTickets",
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.mergeLclCargoDocInfo(
                                        "cargoChineseName",
                                        _vm.form
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.MergingTickets"))
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c("el-input", {
                            class:
                              _vm.form.cargoChineseNameWarning === 1
                                ? "red-border"
                                : "",
                            attrs: {
                              type: "textarea",
                              rows: 3,
                              no: "cargoChineseName"
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                                  _vm.form.cargoChineseName,
                                  function(val) {
                                    _vm.form.cargoChineseName = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.cargoChineseName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cargoChineseName", $$v)
                              },
                              expression: "form.cargoChineseName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "div",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SeaExport.EnglishDescriptionOfGoods"
                                    )
                                  )
                                )
                              ]),
                              _c("br"),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isEdit,
                                      expression: "isEdit"
                                    }
                                  ],
                                  attrs: {
                                    type: "primary",
                                    no: "EnglishDescriptionOfGoods"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.mergeLclCargoDocInfo(
                                        "cargoEnglishName",
                                        _vm.form
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.MergingTickets"))
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "special-character-tip",
                            {
                              attrs: {
                                texts: _vm.specialCharCheck.cargoEnglishName
                              }
                            },
                            [
                              _c("el-input", {
                                class:
                                  _vm.form.cargoEnglishNameWarning === 1
                                    ? "red-border"
                                    : "",
                                attrs: {
                                  no: "cargoEnglishName",
                                  type: "textarea",
                                  rows: 3
                                },
                                on: { input: _vm.handleInputCargoEnglishName },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t(
                                        "SeaExport.EnglishDescriptionOfGoods"
                                      ),
                                      _vm.form.cargoEnglishName,
                                      function(val) {
                                        _vm.form.cargoEnglishName = val
                                      },
                                      _vm.isUppercaseByConfig,
                                      { autoUppercase: _vm.isUppercaseByConfig }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.cargoEnglishName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "cargoEnglishName", $$v)
                                  },
                                  expression: "form.cargoEnglishName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "div",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("SeaExport.Marks")))
                              ]),
                              _c("br"),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isEdit,
                                      expression: "isEdit"
                                    }
                                  ],
                                  attrs: { no: "Marks", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.mergeLclCargoDocInfo(
                                        "mark",
                                        _vm.form
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.MergingTickets"))
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "special-character-tip",
                            { attrs: { texts: _vm.specialCharCheck.mark } },
                            [
                              _c("el-input", {
                                attrs: {
                                  no: "mark",
                                  type: "textarea",
                                  rows: 3
                                },
                                on: { input: _vm.handleInputMark },
                                nativeOn: {
                                  dblclick: function($event) {
                                    _vm.showAdvanceTextDialog(
                                      _vm.$t("SeaExport.Marks"),
                                      _vm.form.mark,
                                      function(val) {
                                        _vm.form.mark = val
                                      },
                                      _vm.isUppercaseByConfig,
                                      { autoUppercase: _vm.isUppercaseByConfig }
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.mark,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "mark", $$v)
                                  },
                                  expression: "form.mark"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "custom",
                          attrs: { label: _vm.$t("SeaExport.CategoryOfGoods") }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "cargoCode",
                              "select-type":
                                _vm.selectTypeNames.basic_data_CargoInformation,
                              disabled: _vm.readonly,
                              filterable: "",
                              clearable: true,
                              "default-value": _vm.form.cargoCode,
                              "allow-create": false
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.pm.cargoCodeChange(p.value)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c("el-input", {
                            attrs: {
                              no: "cargoName",
                              disabled: !(
                                _vm.isEdit &&
                                _vm.form.cargoCode != "" &&
                                _vm.form.cargoCode != null
                              )
                            },
                            model: {
                              value: _vm.form.cargoName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cargoName", $$v)
                              },
                              expression: "form.cargoName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        "label-width": "135px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.OperationInfo")))
                      ]),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.OrderChannels") } },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.form.salesChannel,
                              disabled: true
                            }
                          })
                        ],
                        1
                      ),
                      _vm.showChannelNo
                        ? _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("SeaExport.ChannelNo") } },
                            [
                              _c("el-input", {
                                attrs: {
                                  value: _vm.form.channelNo,
                                  disabled: true
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.ConsignationRelationNumber"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.form.trustFromJob,
                              disabled: true
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "SeaExport.BusinessCommissionedRelationNumber"
                            )
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.form.relatedJob,
                              disabled: true
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.SalesCompany") } },
                        [
                          _c("el-input", {
                            attrs: { value: _vm.txtSalesOffice, disabled: true }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Sales") } },
                        [
                          _c("cargo-user-select", {
                            ref: "sales",
                            attrs: {
                              no: "sales",
                              disbled:
                                !_vm.pm.canChangeSalesOfJob ||
                                _vm.pm.isWithinCloseAccountDate,
                              "method-params": {
                                officeId: _vm.salesOfficeCheck
                                  ? _vm.$store.getters.currentOfficeId
                                  : "",
                                category: "role",
                                shape: "sales"
                              },
                              "default-value": _vm.form.sales || "",
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.txtSalesChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.SalesOfGoods") } },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "cargoSalesId",
                              "method-params": {
                                category: "role",
                                shape: "salesOfGoods"
                              },
                              "default-value": _vm.form.cargoSalesId || "",
                              "merge-load": true,
                              "static-options": _vm.cargoSalesList
                            },
                            on: {
                              change: function(p) {
                                _vm.form.cargoSalesId = p.value
                                _vm.pm.cargoSalesChargeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.SalesDepartment") }
                        },
                        [
                          _c("cargo-department-new-select", {
                            attrs: {
                              no: "salesOffice",
                              disabled: !_vm.form.sales,
                              enables: true,
                              "sales-id": Number(_vm.form.sales),
                              "office-id": _vm.form.salesOffice,
                              "department-id": Number(_vm.form.salesDepartment)
                            },
                            on: {
                              change: function(p) {
                                _vm.form.salesDepartment = p.value
                                _vm.pm.departmentChargeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.OperationCompany") }
                        },
                        [
                          _c("cargo-office-select", {
                            attrs: {
                              no: "opOffice",
                              disabled:
                                (!_vm.isRegionalCommission &&
                                  _vm.pm.isEntrustOrder(true)) ||
                                _vm.opOfficeDisabled,
                              "is-regional-commission":
                                _vm.isRegionalCommission,
                              "office-id": Number(_vm.form.opOffice)
                            },
                            on: {
                              change: function(p) {
                                _vm.form.opOffice = p.value
                                _vm.form.opDepartment = 0
                                _vm.opOfficeChargeHandler()
                                _vm.contractRuleFieldChange(
                                  _vm.form.customerId,
                                  _vm.form.designationAgent
                                )
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.OperationDepartment"))
                              )
                            ]
                          ),
                          _c("cargo-department-select", {
                            attrs: {
                              no: "opDepartment",
                              disabled: _vm.pm.isWithinCloseAccountDate,
                              "office-id": Number(_vm.form.opOffice),
                              enables: true,
                              "department-id": Number(_vm.form.opDepartment)
                            },
                            on: {
                              change: function(p) {
                                _vm.form.opDepartment = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Operation") } },
                        [
                          _c("cargo-user-select", {
                            ref: "op",
                            attrs: {
                              no: "op",
                              disabled: !_vm.opEabled,
                              "method-params": {
                                officeId: _vm.form.opOffice,
                                category: "role",
                                shape: "op"
                              },
                              "default-value": _vm.form.op || "",
                              "merge-load": true,
                              "static-options": _vm.userPortRoleData.op
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.txtOPChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.CustomerOffice") }
                        },
                        [
                          _c("cargo-office-select", {
                            attrs: {
                              no: "csrOffice",
                              disabled: true,
                              "office-id": Number(_vm.form.csrOffice)
                            },
                            on: {
                              change: function(p) {
                                _vm.form.csrOffice = p.value
                                _vm.form.csrDepartment = 0
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v(_vm._s(_vm.$t("Message.Customer_Service")))]
                          ),
                          _c("cargo-department-select", {
                            attrs: {
                              no: "csrDepartment",
                              "office-id": Number(_vm.form.csrOffice),
                              enables: true,
                              "department-id": Number(_vm.form.csrDepartment)
                            },
                            on: {
                              change: function(p) {
                                _vm.form.csrDepartment = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.CustomerService") }
                        },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "csr",
                              "method-params": {
                                officeId:
                                  _vm.pm.isEntrustOrder ||
                                  _vm.fom.salesOffice === 1
                                    ? _vm.form.opOffice
                                    : _vm.form.salesOffice,
                                category: "role",
                                shape: "csr"
                              },
                              "default-value": _vm.form.csr || "",
                              "merge-load": true,
                              "static-options": _vm.userPortRoleData.csr
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.csrChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.FieldOperation") }
                        },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              "method-params": {
                                officeId: _vm.form.opOffice,
                                category: "role",
                                shape: "siteOp"
                              },
                              "default-value": _vm.form.siteOP || "",
                              "static-options": _vm.userPortRoleData.siteOp
                            },
                            on: {
                              change: function(p) {
                                _vm.JobUtils.siteOpChangeHandler(_vm.form, p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.OverseaCustomerService")
                          }
                        },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "overseaOp",
                              "default-value": _vm.form.overseaOp || "",
                              "method-params": {
                                category: "role",
                                shape: "overseaOp"
                              },
                              "static-options": _vm.isHC
                                ? null
                                : _vm.userPortRoleData.overseaOp ||
                                  _vm.overseaOpList,
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.overseaOpChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.DocumentOffice") }
                        },
                        [
                          _c("cargo-office-select", {
                            attrs: {
                              no: "dcOffice",
                              disabled: true,
                              "office-id": Number(_vm.form.dcOffice)
                            },
                            on: {
                              change: function(p) {
                                _vm.form.dcOffice = p.value
                                _vm.form.dcDepartment = 0
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Message.Documentation_Department")
                                )
                              )
                            ]
                          ),
                          _c("cargo-department-select", {
                            attrs: {
                              no: "dcDepartment",
                              "office-id": Number(_vm.form.dcOffice),
                              enables: true,
                              "department-id": Number(_vm.form.dcDepartment)
                            },
                            on: {
                              change: function(p) {
                                _vm.form.dcDepartment = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Documents") } },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "dc",
                              "method-params": {
                                officeId: _vm.form.opOffice,
                                category: "role",
                                shape: "doc"
                              },
                              "default-value": _vm.form.dc || "",
                              "merge-load": true,
                              "static-options": _vm.userPortRoleData.doc
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.dcChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.AirlineOffice") } },
                        [
                          _c("cargo-office-select", {
                            attrs: {
                              no: "plannerOffice",
                              disabled: true,
                              "office-id": Number(_vm.form.plannerOffice)
                            },
                            on: {
                              change: function(p) {
                                _vm.form.plannerOffice = p.value
                                _vm.form.plannerDepartment = 0
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.AirlineDepartment"))
                              )
                            ]
                          ),
                          _c("cargo-department-select", {
                            attrs: {
                              no: "plannerDepartment",
                              "office-id": Number(_vm.form.plannerOffice),
                              enables: true,
                              "department-id": Number(
                                _vm.form.plannerDepartment
                              )
                            },
                            on: {
                              change: function(p) {
                                _vm.form.plannerDepartment = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.AirlinePerson2") }
                        },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "planner",
                              "method-params": {
                                category: "role",
                                shape: "sealine"
                              },
                              "default-value": _vm.form.planner || "",
                              "merge-load": true,
                              "static-options": _vm.userPortRoleData.seaLine
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.txtPlannerChangeHandler(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isAddUserDefinedRoles,
                              expression: "isAddUserDefinedRoles"
                            }
                          ],
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                          }
                        },
                        [
                          _c("cargo-user-select", {
                            ref: "userDefinedRoleId1",
                            attrs: {
                              no: "userDefinedRoleId1",
                              "method-params": {
                                officeId: _vm.$store.getters.currentOfficeId,
                                category: "role",
                                shape: "userDefinedRole1"
                              },
                              "default-value":
                                _vm.form.userDefinedRoleId1 || "",
                              "merge-load": true,
                              "static-options":
                                _vm.userPortRoleData.userDefinedRole1
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.userDefinedRoleId1Handler(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isAddUserDefinedRoles,
                              expression: "isAddUserDefinedRoles"
                            }
                          ],
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                          }
                        },
                        [
                          _c("cargo-user-select", {
                            ref: "userDefinedRoleId2",
                            attrs: {
                              no: "userDefinedRoleId2",
                              "method-params": {
                                officeId: _vm.$store.getters.currentOfficeId,
                                category: "role",
                                shape: "userDefinedRole2"
                              },
                              "default-value":
                                _vm.form.userDefinedRoleId2 || "",
                              "merge-load": true,
                              "static-options":
                                _vm.userPortRoleData.userDefinedRole2
                            },
                            on: {
                              change: function(p) {
                                _vm.pm.userDefinedRoleId2Handler(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "section form-column" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        "label-width": "100px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.UserDefinedArea")))
                      ]),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.UserDefinedField1")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "userDefinedField1",
                              type: "textarea",
                              rows: 5
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.UserDefinedField1"),
                                  _vm.form.userDefinedField1,
                                  function(val) {
                                    _vm.form.userDefinedField1 = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.userDefinedField1,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "userDefinedField1", $$v)
                              },
                              expression: "form.userDefinedField1"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.UserDefinedField2")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "userDefinedField2",
                              type: "textarea",
                              rows: 5
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.UserDefinedField2"),
                                  _vm.form.userDefinedField2,
                                  function(val) {
                                    _vm.form.userDefinedField2 = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.userDefinedField2,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "userDefinedField2", $$v)
                              },
                              expression: "form.userDefinedField2"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.UserDefinedField3")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "userDefinedField3",
                              type: "textarea",
                              rows: 5
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.UserDefinedField3"),
                                  _vm.form.userDefinedField3,
                                  function(val) {
                                    _vm.form.userDefinedField3 = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.userDefinedField3,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "userDefinedField3", $$v)
                              },
                              expression: "form.userDefinedField3"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.UserDefinedField4")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "userDefinedField4",
                              type: "textarea",
                              rows: 5
                            },
                            nativeOn: {
                              dblclick: function($event) {
                                _vm.showAdvanceTextDialog(
                                  _vm.$t("SeaExport.UserDefinedField4"),
                                  _vm.form.userDefinedField4,
                                  function(val) {
                                    _vm.form.userDefinedField4 = val
                                  }
                                )
                              }
                            },
                            model: {
                              value: _vm.form.userDefinedField4,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "userDefinedField4", $$v)
                              },
                              expression: "form.userDefinedField4"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.TaxNature") } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                no: "taxNature",
                                placeholder: _vm.$t("SeaExport.PleaseSelect"),
                                size: "mini"
                              },
                              model: {
                                value: _vm.form.taxNature,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "taxNature", $$v)
                                },
                                expression: "form.taxNature"
                              }
                            },
                            _vm._l(_vm.TAX_NATURES, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm.isZh
                                    ? item.chineseName
                                    : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "section", staticStyle: { width: "100%" } },
              [
                _c("div", { staticClass: "title" }, [
                  _vm._v(" " + _vm._s(_vm.$t("SeaExport.TicketsInfo")) + " "),
                  _c(
                    "div",
                    {
                      ref: "division",
                      staticClass: "division",
                      style: { height: _vm.divisionHeight + "px" },
                      on: {
                        mousedown: function($event) {
                          _vm.divisionEnabled = true
                        }
                      }
                    },
                    [
                      _c("div", {
                        staticClass: "line",
                        staticStyle: { "margin-top": "2px" }
                      }),
                      _c("div", { staticClass: "line" })
                    ]
                  )
                ]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "column",
                      "margin-bottom": "5px",
                      "line-height": "28px"
                    }
                  },
                  [
                    _c("div", { staticStyle: { padding: "5px 0" } }, [
                      _c("span", { staticStyle: { "margin-right": "5px" } }, [
                        _vm._v(_vm._s(_vm.$t("SeaExport.TotalTickets")) + ":")
                      ]),
                      _c("span", { staticStyle: { "margin-right": "5px" } }, [
                        _vm._v(_vm._s(_vm.form.lclSlaves.length))
                      ]),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.readonly &&
                                _vm.viewSource === "bookingWorkspace",
                              expression:
                                "readonly&&viewSource==='bookingWorkspace'"
                            }
                          ],
                          staticStyle: { display: "inline-flex" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "NewTickets",
                                disabled:
                                  !_vm.isSeaExport ||
                                  _vm.viewSource === "financeDetail" ||
                                  _vm.viewSource === "salesDetail",
                                type: "primary"
                              },
                              on: { click: _vm.btnCreateClickHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.NewTickets")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "EditTickets",
                                disabled:
                                  !_vm.selectedRow ||
                                  _vm.viewSource === "financeDetail" ||
                                  _vm.viewSource === "salesDetail",
                                type: "primary"
                              },
                              on: { click: _vm.btnLcLEditClickHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.EditTickets")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "AddTickets",
                                disabled:
                                  !_vm.isSeaExport ||
                                  _vm.viewSource === "financeDetail" ||
                                  _vm.viewSource === "salesDetail",
                                type: "primary"
                              },
                              on: { click: _vm.btnImportLclClickHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.AddTickets")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                no: "RemoveTickets",
                                disabled:
                                  !_vm.selectedRow ||
                                  _vm.viewSource === "financeDetail" ||
                                  _vm.viewSource === "salesDetail",
                                type: "danger"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.pm.btnRemoveBatchClickHandler()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.RemoveTickets")))]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "permission",
                                  rawName: "v-permission",
                                  value: [
                                    "button_fmBookingNew_deleteSmallTicket"
                                  ],
                                  expression:
                                    "['button_fmBookingNew_deleteSmallTicket']"
                                }
                              ],
                              attrs: {
                                no: "DeleteTickets",
                                disabled:
                                  !_vm.selectedRow ||
                                  _vm.viewSource === "financeDetail" ||
                                  _vm.viewSource === "salesDetail",
                                type: "danger"
                              },
                              on: { click: _vm.btnRemoveClickHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.DeleteTickets")))]
                          )
                        ],
                        1
                      )
                    ]),
                    _c(
                      "div",
                      { ref: "slaveDiv", staticStyle: { display: "flex" } },
                      [
                        _c("cargo-ag-grid", {
                          attrs: {
                            "config-module": "130125",
                            "grid-options": _vm.gridOptions,
                            "column-defs": _vm.columnDefs,
                            "row-data": _vm.rowData
                          },
                          on: {
                            gridReady: function(params) {
                              _vm.gridApi = params.api
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]
            )
          ]),
          _c("query-se-lcl-dialog", {
            attrs: { visible: _vm.querySELclDialog.visible, job: _vm.form },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.querySELclDialog, "visible", $event)
              },
              callback: function(rows) {
                _vm.pm.slavedAddedHandler(rows)
              }
            }
          }),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "ticketDialog",
                visible: _vm.ticketDialog.visible,
                title: _vm.$t("SeaExport.FillInQuantityOfVotes"),
                width: "270px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.ticketDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "50px", "label-position": "right" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Number") + "：" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          precision: 0,
                          min: 1,
                          max: 50,
                          controls: false
                        },
                        model: {
                          value: _vm.ticketDialog.value,
                          callback: function($$v) {
                            _vm.$set(_vm.ticketDialog, "value", $$v)
                          },
                          expression: "ticketDialog.value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "ticketDialogConfirm", type: "primary" },
                      on: { click: _vm.toAddTicket }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "ticketDialogCancel", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.ticketDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "ContactPerson",
                visible: _vm.contactDialog.visible,
                title: _vm.$t("SeaExport.ContactPerson"),
                width: "400px",
                "append-to-body": "",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.contactDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  attrs: { "label-position": "right", "label-width": "100px" }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.ContactPerson") + "：" }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "170px" },
                        attrs: {
                          disabled: true,
                          value: _vm.contactDialog.data.contactPerson
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Role") + "：" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "170px" },
                        attrs: {
                          disabled: true,
                          value: _vm.contactDialog.data.role
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Tel") + "：" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "170px" },
                        attrs: {
                          disabled: true,
                          value: _vm.contactDialog.data.telephone
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Mobile") + "：" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "170px" },
                        attrs: {
                          disabled: true,
                          value: _vm.contactDialog.data.mobile
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Fax") + "：" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "170px" },
                        attrs: {
                          disabled: true,
                          value: _vm.contactDialog.data.fax
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Email") + "：" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "170px" },
                        attrs: {
                          disabled: true,
                          value: _vm.contactDialog.data.email
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") + "：" }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "170px" },
                        attrs: {
                          disabled: true,
                          value: _vm.contactDialog.data.remarks,
                          type: "textarea",
                          rows: 3
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "advanceTextDialog",
                visible: _vm.advanceTextDialog.visible,
                title: _vm.advanceTextDialog.title,
                width: "600px",
                "close-on-click-modal": false,
                "close-on-press-escape": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.advanceTextDialog, "visible", $event)
                }
              }
            },
            [
              _c("cargo-rich-textarea", {
                ref: "advanceTextDialogTextarea",
                staticStyle: { height: "320px" },
                attrs: {
                  disabled: _vm.readonly,
                  "auto-uppercase":
                    _vm.advanceTextDialog.formatObj.autoUppercase
                },
                model: {
                  value: _vm.advanceTextDialog.value,
                  callback: function($$v) {
                    _vm.$set(_vm.advanceTextDialog, "value", $$v)
                  },
                  expression: "advanceTextDialog.value"
                }
              }),
              _c(
                "span",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEdit,
                          expression: "isEdit"
                        }
                      ],
                      attrs: {
                        no: "advanceTextDialogConfirm",
                        type: "primary"
                      },
                      on: { click: _vm.finishAdvanceText }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "advanceTextDialogClose" },
                      on: {
                        click: function($event) {
                          _vm.advanceTextDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }